import * as React from 'react';
import { RegistrationSchoolPicker } from './RegistrationSchoolPicker';

interface Props {
  phone: string;
  onSubmit: (data) => void;
  onBack: (draft?: any) => void;
  initialSchool?: any;
  initialOneOffCode?: string;
}

export class StudentPermission extends React.Component<Props> {
  render() {
    return <RegistrationSchoolPicker {...this.props} role="STUDENT" />;
  }
}
